import _ from 'lodash';
import ReactYouTube from 'react-youtube';
import styled from 'styled-components';

const FrameContainer = styled.div`
  display: block;
  padding-bottom: 56.25%;
  position: relative;
  width: 100%;
  border-radius: ${({ theme }) => _.toInteger(theme.shape.borderRadius) * 3}px;
`;

const StyledReactYoutube = styled(ReactYouTube)`
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: ${({ theme }) => theme.shape.borderRadius * 3}px;
  & > * {
    border-radius: ${({ theme }) => _.toInteger(theme.shape.borderRadius) * 3}px;
  }
`;

const YouTubeRedirectBlock = styled.div`
  position: absolute;
  z-index: 4000; // to cover the embedded YouTube video
  width: 68px;
  height: 40px;
  right: 52px;
  bottom: 0;
`;

const YouTubeTopBlock = styled.div`
  position: absolute;
  z-index: 4; // to cover the embedded YouTube video
  width: 100%;
  height: 60px;
  top: 0;
`;

export { FrameContainer,
  StyledReactYoutube,
  YouTubeTopBlock,
  YouTubeRedirectBlock };
